
<div class="form-separator-line"></div>

<div class="form-separator-content">
  <span><ng-content></ng-content></span>
</div>

<div class="form-separator-line"></div>